/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

import { CustomerDto, MasterAgency, MasterAgencyListDto, Partner, PartnerAcquisitionListDto, PartnerSourceType, PartnerStatus, PartnerSupportType, ProviderEditDto, SplitType } from './common-proxies';
import { API_BASE_URL, blobToText, throwException } from './proxy-helpers';
import { PartnerEditDto, PartnerSupportEditDto, PartnersDto, UserListDto } from './shared-models';

@Injectable()
export class MasterAgencyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getMasterAgencies(): Observable<MasterAgencyListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/MasterAgency/GetMasterAgencies';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetMasterAgencies(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetMasterAgencies(<any>response_);
                        } catch (e) {
                            return <Observable<MasterAgencyListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<MasterAgencyListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetMasterAgencies(response: HttpResponseBase): Observable<MasterAgencyListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(MasterAgencyListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<MasterAgencyListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @param name (optional)
     * @param isMCRevenue (optional)
     * @return Success
     */
    getMasterAgency(id: number | undefined, name: string | undefined, isMCRevenue: boolean | undefined): Observable<MasterAgency> {
        let url_ = this.baseUrl + '/api/services/app/MasterAgency/GetMasterAgency?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'Name=' + encodeURIComponent('' + name) + '&';
        if (isMCRevenue === null) throw new Error("The parameter 'isMCRevenue' cannot be null.");
        else if (isMCRevenue !== undefined) url_ += 'IsMCRevenue=' + encodeURIComponent('' + isMCRevenue) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetMasterAgency(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetMasterAgency(<any>response_);
                        } catch (e) {
                            return <Observable<MasterAgency>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<MasterAgency>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetMasterAgency(response: HttpResponseBase): Observable<MasterAgency> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = MasterAgency.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<MasterAgency>(<any>null);
    }

    /**
     * @param id (optional)
     * @param name (optional)
     * @param isMCRevenue (optional)
     * @return Success
     */
    deleteMasterAgency(id: number | undefined, name: string | undefined, isMCRevenue: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/MasterAgency/DeleteMasterAgency?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'Name=' + encodeURIComponent('' + name) + '&';
        if (isMCRevenue === null) throw new Error("The parameter 'isMCRevenue' cannot be null.");
        else if (isMCRevenue !== undefined) url_ += 'IsMCRevenue=' + encodeURIComponent('' + isMCRevenue) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteMasterAgency(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteMasterAgency(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteMasterAgency(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateMasterAgency(body: MasterAgencyInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/MasterAgency/CreateOrUpdateMasterAgency';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateMasterAgency(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateMasterAgency(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateMasterAgency(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PartnerAcquisitionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getPartnerAcquisitions(): Observable<PartnerAcquisitionDto[]> {
        let url_ = this.baseUrl + '/api/services/app/PartnerAcquisition/GetPartnerAcquisitions';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerAcquisitions(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerAcquisitions(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerAcquisitionDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerAcquisitionDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerAcquisitions(response: HttpResponseBase): Observable<PartnerAcquisitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnerAcquisitionDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerAcquisitionDto[]>([]);
    }

    /**
     * @param acquisitionId (optional)
     * @return Success
     */
    getPartnerAcquisition(acquisitionId: number | undefined): Observable<PartnerAcquisitionDto> {
        let url_ = this.baseUrl + '/api/services/app/PartnerAcquisition/GetPartnerAcquisition?';
        if (acquisitionId === null) throw new Error("The parameter 'acquisitionId' cannot be null.");
        else if (acquisitionId !== undefined) url_ += 'acquisitionId=' + encodeURIComponent('' + acquisitionId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerAcquisition(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerAcquisition(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerAcquisitionDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerAcquisitionDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerAcquisition(response: HttpResponseBase): Observable<PartnerAcquisitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = PartnerAcquisitionDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerAcquisitionDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdatePartnerAcquisition(body: PartnerAcquisitionEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/PartnerAcquisition/CreateOrUpdatePartnerAcquisition';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdatePartnerAcquisition(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdatePartnerAcquisition(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdatePartnerAcquisition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PartnerContractTermServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param partnerId (optional)
     * @param order (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getPartnerContractTerms(
        partnerId: number | undefined,
        order: PartnerContactTermStatus | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined,
        rateTypeId: number | undefined,
        customerId: number | undefined,
        campaignId: number | undefined
    ): Observable<PartnerContractTermDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/PartnerContractTerm/GetPartnerContractTerms?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (order === null) throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined) url_ += 'Order=' + encodeURIComponent('' + order) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        if (rateTypeId === null) throw new Error("The parameter 'rateTypeId' cannot be null.");
        else if (rateTypeId !== undefined) url_ += 'CommissionTrackingTypeId=' + encodeURIComponent('' + rateTypeId) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'CustomerId=' + encodeURIComponent('' + customerId) + '&';
        if (campaignId === null) throw new Error("The parameter 'campaignId' cannot be null.");
        else if (campaignId !== undefined) url_ += 'SalesCampaignId=' + encodeURIComponent('' + campaignId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerContractTerms(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerContractTerms(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerContractTermDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerContractTermDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerContractTerms(response: HttpResponseBase): Observable<PartnerContractTermDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = PartnerContractTermDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerContractTermDtoPagedResultDto>(<any>null);
    }

    /**
     * @param contractTermId (optional)
     * @return Success
     */
    getPartnerContractTerm(contractTermId: number | undefined): Observable<PartnerContractTermDto> {
        let url_ = this.baseUrl + '/api/services/app/PartnerContractTerm/GetPartnerContractTerm?';
        if (contractTermId === null) throw new Error("The parameter 'contractTermId' cannot be null.");
        else if (contractTermId !== undefined) url_ += 'contractTermId=' + encodeURIComponent('' + contractTermId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerContractTerm(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerContractTerm(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerContractTermDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerContractTermDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerContractTerm(response: HttpResponseBase): Observable<PartnerContractTermDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = PartnerContractTermDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerContractTermDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdatePartnerContractTerms(body: PartnerContractTermsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/PartnerContractTerm/CreateOrUpdatePartnerContractTerms';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdatePartnerContractTerms(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdatePartnerContractTerms(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdatePartnerContractTerms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deletePartnerContractTerm(id: number | undefined): Observable<ValidationResponse> {
        let url_ = this.baseUrl + '/api/services/app/PartnerContractTerm/DeletePartnerContractTerm?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeletePartnerContractTerm(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeletePartnerContractTerm(<any>response_);
                        } catch (e) {
                            return <Observable<ValidationResponse>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ValidationResponse>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeletePartnerContractTerm(response: HttpResponseBase): Observable<ValidationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ValidationResponse.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ValidationResponse>(<any>null);
    }

    /**
     * @param partnerId (optional)
     * @param effectiveDate (optional)
     * @param providerId (optional)
     * @param salesCampaignId (optional)
     * @param commissionTrackingTypeId (optional)
     * @return Success
     */
    getPartnerContractTermOrDefault(
        partnerId: number | undefined,
        effectiveDate: moment.Moment | undefined,
        providerId: number | undefined,
        salesCampaignId: number | undefined,
        commissionTrackingTypeId: number | undefined
    ): Observable<PartnerContractTermDto> {
        let url_ = this.baseUrl + '/api/services/app/PartnerContractTerm/GetPartnerContractTermOrDefault?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (effectiveDate === null) throw new Error("The parameter 'effectiveDate' cannot be null.");
        else if (effectiveDate !== undefined)
            url_ += 'EffectiveDate=' + encodeURIComponent(effectiveDate ? '' + effectiveDate.toJSON() : '') + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (salesCampaignId === null) throw new Error("The parameter 'salesCampaignId' cannot be null.");
        else if (salesCampaignId !== undefined) url_ += 'SalesCampaignId=' + encodeURIComponent('' + salesCampaignId) + '&';
        if (commissionTrackingTypeId === null) throw new Error("The parameter 'commissionTrackingTypeId' cannot be null.");
        else if (commissionTrackingTypeId !== undefined)
            url_ += 'CommissionTrackingTypeId=' + encodeURIComponent('' + commissionTrackingTypeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerContractTermOrDefault(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerContractTermOrDefault(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerContractTermDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerContractTermDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerContractTermOrDefault(response: HttpResponseBase): Observable<PartnerContractTermDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = PartnerContractTermDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerContractTermDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @param partnerId (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @param commissionTrackingTypeId (optional)
     * @param providerId (optional)
     * @param salesCampaignId (optional)
     * @return Success
     */
    detectConflict(
        id: number | undefined,
        partnerId: number | undefined,
        startDate: moment.Moment | undefined,
        endDate: moment.Moment | undefined,
        commissionTrackingTypeId: number | undefined,
        providerId: number | undefined,
        salesCampaignId: number | undefined
    ): Observable<ValidationResponse> {
        let url_ = this.baseUrl + '/api/services/app/PartnerContractTerm/DetectConflict?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'startDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'endDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&';
        if (commissionTrackingTypeId === null) throw new Error("The parameter 'commissionTrackingTypeId' cannot be null.");
        else if (commissionTrackingTypeId !== undefined)
            url_ += 'commissionTrackingTypeId=' + encodeURIComponent('' + commissionTrackingTypeId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        if (salesCampaignId === null) throw new Error("The parameter 'salesCampaignId' cannot be null.");
        else if (salesCampaignId !== undefined) url_ += 'salesCampaignId=' + encodeURIComponent('' + salesCampaignId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDetectConflict(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDetectConflict(<any>response_);
                        } catch (e) {
                            return <Observable<ValidationResponse>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ValidationResponse>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDetectConflict(response: HttpResponseBase): Observable<ValidationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ValidationResponse.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ValidationResponse>(<any>null);
    }
}

export class CommissionTrackingTypeDto implements ICommissionTrackingTypeDto {
    name: string | undefined;
    isCommissionProcess: boolean;
    hasRate: boolean;
    id: number;

    constructor(data?: ICommissionTrackingTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.isCommissionProcess = _data['isCommissionProcess'];
            this.hasRate = _data['hasRate'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CommissionTrackingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionTrackingTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['isCommissionProcess'] = this.isCommissionProcess;
        data['hasRate'] = this.hasRate;
        data['id'] = this.id;
        return data;
    }

    clone(): CommissionTrackingTypeDto {
        const json = this.toJSON();
        let result = new CommissionTrackingTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionTrackingTypeDto {
    name: string | undefined;
    isCommissionProcess: boolean;
    hasRate: boolean;
    id: number;
}

export class CreateOrUpdatePartnerDevelopmentInput implements ICreateOrUpdatePartnerDevelopmentInput {
    partnerDevelopment: PartnerDevelopmentEditDto;

    constructor(data?: ICreateOrUpdatePartnerDevelopmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.partnerDevelopment = new PartnerDevelopmentEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerDevelopment = _data['partnerDevelopment']
                ? PartnerDevelopmentEditDto.fromJS(_data['partnerDevelopment'])
                : new PartnerDevelopmentEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdatePartnerDevelopmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePartnerDevelopmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerDevelopment'] = this.partnerDevelopment ? this.partnerDevelopment.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdatePartnerDevelopmentInput {
        const json = this.toJSON();
        let result = new CreateOrUpdatePartnerDevelopmentInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdatePartnerDevelopmentInput {
    partnerDevelopment: PartnerDevelopmentEditDto;
}

export class CreateOrUpdatePartnerDocumentInput implements ICreateOrUpdatePartnerDocumentInput {
    partnerDocument: PartnerDocumentDto;

    constructor(data?: ICreateOrUpdatePartnerDocumentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.partnerDocument = new PartnerDocumentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerDocument = _data['partnerDocument']
                ? PartnerDocumentDto.fromJS(_data['partnerDocument'])
                : new PartnerDocumentDto();
        }
    }

    static fromJS(data: any): CreateOrUpdatePartnerDocumentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePartnerDocumentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerDocument'] = this.partnerDocument ? this.partnerDocument.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdatePartnerDocumentInput {
        const json = this.toJSON();
        let result = new CreateOrUpdatePartnerDocumentInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdatePartnerDocumentInput {
    partnerDocument: PartnerDocumentDto;
}

export class CreateOrUpdatePartnerInput implements ICreateOrUpdatePartnerInput {
    partner: PartnerEditDto;

    constructor(data?: ICreateOrUpdatePartnerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.partner = new PartnerEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data['partner'] ? PartnerEditDto.fromJS(_data['partner']) : new PartnerEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdatePartnerInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePartnerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdatePartnerInput {
        const json = this.toJSON();
        let result = new CreateOrUpdatePartnerInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdatePartnerInput {
    partner: PartnerEditDto;
}

export class CreateOrUpdatePartnerSalesSupportInput implements ICreateOrUpdatePartnerSalesSupportInput {
    partnerSalesSupport: PartnerSalesSupportEditDto;

    constructor(data?: ICreateOrUpdatePartnerSalesSupportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerSalesSupport = _data['partnerSalesSupport']
                ? PartnerSalesSupportEditDto.fromJS(_data['partnerSalesSupport'])
                : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdatePartnerSalesSupportInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePartnerSalesSupportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerSalesSupport'] = this.partnerSalesSupport ? this.partnerSalesSupport.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdatePartnerSalesSupportInput {
        const json = this.toJSON();
        let result = new CreateOrUpdatePartnerSalesSupportInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdatePartnerSalesSupportInput {
    partnerSalesSupport: PartnerSalesSupportEditDto;
}

export class CreateOrUpdatePartnerSourceInput implements ICreateOrUpdatePartnerSourceInput {
    partnerSource: PartnerSourceEditDto;

    constructor(data?: ICreateOrUpdatePartnerSourceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.partnerSource = new PartnerSourceEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerSource = _data['partnerSource'] ? PartnerSourceEditDto.fromJS(_data['partnerSource']) : new PartnerSourceEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdatePartnerSourceInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePartnerSourceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerSource'] = this.partnerSource ? this.partnerSource.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdatePartnerSourceInput {
        const json = this.toJSON();
        let result = new CreateOrUpdatePartnerSourceInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdatePartnerSourceInput {
    partnerSource: PartnerSourceEditDto;
}

export class CreateOrUpdatePartnerSubAgencyInput implements ICreateOrUpdatePartnerSubAgencyInput {
    partnerSubAgency: PartnerSubAgencyEditDto;

    constructor(data?: ICreateOrUpdatePartnerSubAgencyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerSubAgency = _data['partnerSubAgency'] ? PartnerSubAgencyEditDto.fromJS(_data['partnerSubAgency']) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdatePartnerSubAgencyInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePartnerSubAgencyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerSubAgency'] = this.partnerSubAgency ? this.partnerSubAgency.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdatePartnerSubAgencyInput {
        const json = this.toJSON();
        let result = new CreateOrUpdatePartnerSubAgencyInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdatePartnerSubAgencyInput {
    partnerSubAgency: PartnerSubAgencyEditDto;
}

export class CreateOrUpdatePartnerSupportInput implements ICreateOrUpdatePartnerSupportInput {
    partnerSupport: PartnerSupportEditDto;

    constructor(data?: ICreateOrUpdatePartnerSupportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.partnerSupport = new PartnerSupportEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerSupport = _data['partnerSupport']
                ? PartnerSupportEditDto.fromJS(_data['partnerSupport'])
                : new PartnerSupportEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdatePartnerSupportInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePartnerSupportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerSupport'] = this.partnerSupport ? this.partnerSupport.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdatePartnerSupportInput {
        const json = this.toJSON();
        let result = new CreateOrUpdatePartnerSupportInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdatePartnerSupportInput {
    partnerSupport: PartnerSupportEditDto;
}

export class CreatePartnerFromOpportunityInput implements ICreatePartnerFromOpportunityInput {
    partnerName: string;
    address: string | undefined;
    city: string;
    state: string;
    zipcode: string | undefined;
    taxId: string | undefined;
    contractTypeId: number | undefined;
    contactFirstName: string;
    contactLastName: string;
    contactPhone: string;
    contactEmail: string;

    constructor(data?: ICreatePartnerFromOpportunityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerName = _data['partnerName'];
            this.address = _data['address'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.taxId = _data['taxId'];
            this.contractTypeId = _data['contractTypeId'];
            this.contactFirstName = _data['contactFirstName'];
            this.contactLastName = _data['contactLastName'];
            this.contactPhone = _data['contactPhone'];
            this.contactEmail = _data['contactEmail'];
        }
    }

    static fromJS(data: any): CreatePartnerFromOpportunityInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerFromOpportunityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerName'] = this.partnerName;
        data['address'] = this.address;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['taxId'] = this.taxId;
        data['contractTypeId'] = this.contractTypeId;
        data['contactFirstName'] = this.contactFirstName;
        data['contactLastName'] = this.contactLastName;
        data['contactPhone'] = this.contactPhone;
        data['contactEmail'] = this.contactEmail;
        return data;
    }

    clone(): CreatePartnerFromOpportunityInput {
        const json = this.toJSON();
        let result = new CreatePartnerFromOpportunityInput();
        result.init(json);
        return result;
    }
}

export interface ICreatePartnerFromOpportunityInput {
    partnerName: string;
    address: string | undefined;
    city: string;
    state: string;
    zipcode: string | undefined;
    taxId: string | undefined;
    contractTypeId: number | undefined;
    contactFirstName: string;
    contactLastName: string;
    contactPhone: string;
    contactEmail: string;
}

export class DropdownDto implements IDropdownDto {
    id: number;
    name: string | undefined;

    constructor(data?: IDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): DropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new DropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): DropdownDto {
        const json = this.toJSON();
        let result = new DropdownDto();
        result.init(json);
        return result;
    }
}

export interface IDropdownDto {
    id: number;
    name: string | undefined;
}

export class GetPartnerActivityMilestoneListDto implements IGetPartnerActivityMilestoneListDto {
    id: number;
    name: string;
    order: number;
    isRequired: boolean;
    partnerStatusView: string;
    isEnabled: boolean;

    constructor(data?: IGetPartnerActivityMilestoneListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.order = _data['order'];
            this.isRequired = _data['isRequired'];
            this.partnerStatusView = _data['partnerStatusView'];
            this.isEnabled = _data['isEnabled'];
        }
    }

    static fromJS(data: any): GetPartnerActivityMilestoneListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerActivityMilestoneListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['order'] = this.order;
        data['isRequired'] = this.isRequired;
        data['partnerStatusView'] = this.partnerStatusView;
        data['isEnabled'] = this.isEnabled;
        return data;
    }

    clone(): GetPartnerActivityMilestoneListDto {
        const json = this.toJSON();
        let result = new GetPartnerActivityMilestoneListDto();
        result.init(json);
        return result;
    }
}

export interface IGetPartnerActivityMilestoneListDto {
    id: number;
    name: string;
    order: number;
    isRequired: boolean;
    partnerStatusView: string;
    isEnabled: boolean;
}

export class GetPartnerDevelopmentListDto implements IGetPartnerDevelopmentListDto {
    id: number;
    provider: string | undefined;
    providerUser: string | undefined;
    partner: string | undefined;
    partnerId: number;
    partnerSince: moment.Moment | undefined;
    partnerUser: string | undefined;
    partnerUserEmail: string | undefined;
    partnerUserPhone: string | undefined;
    creationTime: moment.Moment;
    status: string | undefined;
    creatorUserId: number | undefined;
    creatorUser: string | undefined;
    quoteCount: number;
    quoteValue: number;
    sales: number;

    constructor(data?: IGetPartnerDevelopmentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.provider = _data['provider'];
            this.providerUser = _data['providerUser'];
            this.partner = _data['partner'];
            this.partnerId = _data['partnerId'];
            this.partnerSince = _data['partnerSince'] ? moment(_data['partnerSince'].toString()) : <any>undefined;
            this.partnerUser = _data['partnerUser'];
            this.partnerUserEmail = _data['partnerUserEmail'];
            this.partnerUserPhone = _data['partnerUserPhone'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.status = _data['status'];
            this.creatorUserId = _data['creatorUserId'];
            this.creatorUser = _data['creatorUser'];
            this.quoteCount = _data['quoteCount'];
            this.quoteValue = _data['quoteValue'];
            this.sales = _data['sales'];
        }
    }

    static fromJS(data: any): GetPartnerDevelopmentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerDevelopmentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['provider'] = this.provider;
        data['providerUser'] = this.providerUser;
        data['partner'] = this.partner;
        data['partnerId'] = this.partnerId;
        data['partnerSince'] = this.partnerSince ? this.partnerSince.toISOString() : <any>undefined;
        data['partnerUser'] = this.partnerUser;
        data['partnerUserEmail'] = this.partnerUserEmail;
        data['partnerUserPhone'] = this.partnerUserPhone;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['status'] = this.status;
        data['creatorUserId'] = this.creatorUserId;
        data['creatorUser'] = this.creatorUser;
        data['quoteCount'] = this.quoteCount;
        data['quoteValue'] = this.quoteValue;
        data['sales'] = this.sales;
        return data;
    }

    clone(): GetPartnerDevelopmentListDto {
        const json = this.toJSON();
        let result = new GetPartnerDevelopmentListDto();
        result.init(json);
        return result;
    }
}

export interface IGetPartnerDevelopmentListDto {
    id: number;
    provider: string | undefined;
    providerUser: string | undefined;
    partner: string | undefined;
    partnerId: number;
    partnerSince: moment.Moment | undefined;
    partnerUser: string | undefined;
    partnerUserEmail: string | undefined;
    partnerUserPhone: string | undefined;
    creationTime: moment.Moment;
    status: string | undefined;
    creatorUserId: number | undefined;
    creatorUser: string | undefined;
    quoteCount: number;
    quoteValue: number;
    sales: number;
}

export class GetPartnerDevelopmentStatusNameDto implements IGetPartnerDevelopmentStatusNameDto {
    statusName: string | undefined;

    constructor(data?: IGetPartnerDevelopmentStatusNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusName = _data['statusName'];
        }
    }

    static fromJS(data: any): GetPartnerDevelopmentStatusNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerDevelopmentStatusNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['statusName'] = this.statusName;
        return data;
    }

    clone(): GetPartnerDevelopmentStatusNameDto {
        const json = this.toJSON();
        let result = new GetPartnerDevelopmentStatusNameDto();
        result.init(json);
        return result;
    }
}

export interface IGetPartnerDevelopmentStatusNameDto {
    statusName: string | undefined;
}

export class GetPartnerForEditOutput implements IGetPartnerForEditOutput {
    partner: PartnerEditDto;

    constructor(data?: IGetPartnerForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data['partner'] ? PartnerEditDto.fromJS(_data['partner']) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPartnerForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetPartnerForEditOutput {
        const json = this.toJSON();
        let result = new GetPartnerForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetPartnerForEditOutput {
    partner: PartnerEditDto;
}

export class GetPartnerNameDto implements IGetPartnerNameDto {
    partnerName: string | undefined;

    constructor(data?: IGetPartnerNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerName = _data['partnerName'];
        }
    }

    static fromJS(data: any): GetPartnerNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerName'] = this.partnerName;
        return data;
    }

    clone(): GetPartnerNameDto {
        const json = this.toJSON();
        let result = new GetPartnerNameDto();
        result.init(json);
        return result;
    }
}

export interface IGetPartnerNameDto {
    partnerName: string | undefined;
}

export class GetPartnerQuotesByProviderListDto implements IGetPartnerQuotesByProviderListDto {
    partnerId: number;
    partnerName: string | undefined;
    ytdSales: number;
    previousYearSales: number;
    priorYearSales: number;

    constructor(data?: IGetPartnerQuotesByProviderListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.ytdSales = _data['ytdSales'];
            this.previousYearSales = _data['previousYearSales'];
            this.priorYearSales = _data['priorYearSales'];
        }
    }

    static fromJS(data: any): GetPartnerQuotesByProviderListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerQuotesByProviderListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['ytdSales'] = this.ytdSales;
        data['previousYearSales'] = this.previousYearSales;
        data['priorYearSales'] = this.priorYearSales;
        return data;
    }

    clone(): GetPartnerQuotesByProviderListDto {
        const json = this.toJSON();
        let result = new GetPartnerQuotesByProviderListDto();
        result.init(json);
        return result;
    }
}

export interface IGetPartnerQuotesByProviderListDto {
    partnerId: number;
    partnerName: string | undefined;
    ytdSales: number;
    previousYearSales: number;
    priorYearSales: number;
}

export class GetPartnerSalesByProviderListDto implements IGetPartnerSalesByProviderListDto {
    partnerId: number;
    partnerName: string | undefined;
    ytdSales: number;
    previousYearSales: number;
    priorYearSales: number;

    constructor(data?: IGetPartnerSalesByProviderListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.ytdSales = _data['ytdSales'];
            this.previousYearSales = _data['previousYearSales'];
            this.priorYearSales = _data['priorYearSales'];
        }
    }

    static fromJS(data: any): GetPartnerSalesByProviderListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerSalesByProviderListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['ytdSales'] = this.ytdSales;
        data['previousYearSales'] = this.previousYearSales;
        data['priorYearSales'] = this.priorYearSales;
        return data;
    }

    clone(): GetPartnerSalesByProviderListDto {
        const json = this.toJSON();
        let result = new GetPartnerSalesByProviderListDto();
        result.init(json);
        return result;
    }
}

export interface IGetPartnerSalesByProviderListDto {
    partnerId: number;
    partnerName: string | undefined;
    ytdSales: number;
    previousYearSales: number;
    priorYearSales: number;
}

export class GetPartnerSourceListDto implements IGetPartnerSourceListDto {
    id: number;
    partnerId: number;
    type: PartnerSourceType;
    name: string | undefined;

    constructor(data?: IGetPartnerSourceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.partnerId = _data['partnerId'];
            this.type = _data['type'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): GetPartnerSourceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerSourceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['partnerId'] = this.partnerId;
        data['type'] = this.type;
        data['name'] = this.name;
        return data;
    }

    clone(): GetPartnerSourceListDto {
        const json = this.toJSON();
        let result = new GetPartnerSourceListDto();
        result.init(json);
        return result;
    }
}

export interface IGetPartnerSourceListDto {
    id: number;
    partnerId: number;
    type: PartnerSourceType;
    name: string | undefined;
}

export class GetPartnerSourceListDtoPagedResultDto implements IGetPartnerSourceListDtoPagedResultDto {
    totalCount: number;
    items: GetPartnerSourceListDto[] | undefined;

    constructor(data?: IGetPartnerSourceListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(GetPartnerSourceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPartnerSourceListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerSourceListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetPartnerSourceListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new GetPartnerSourceListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGetPartnerSourceListDtoPagedResultDto {
    totalCount: number;
    items: GetPartnerSourceListDto[] | undefined;
}

export class GetPartnerSupportUsersDto implements IGetPartnerSupportUsersDto {
    users: UserPartnerSupportInfoDto[] | undefined;
    type: PartnerSupportType;

    constructor(data?: IGetPartnerSupportUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['users'])) {
                this.users = [] as any;
                for (let item of _data['users']) this.users.push(UserPartnerSupportInfoDto.fromJS(item));
            }
            this.type = _data['type'];
        }
    }

    static fromJS(data: any): GetPartnerSupportUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerSupportUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data['users'] = [];
            for (let item of this.users) data['users'].push(item.toJSON());
        }
        data['type'] = this.type;
        return data;
    }

    clone(): GetPartnerSupportUsersDto {
        const json = this.toJSON();
        let result = new GetPartnerSupportUsersDto();
        result.init(json);
        return result;
    }
}

export interface IGetPartnerSupportUsersDto {
    users: UserPartnerSupportInfoDto[] | undefined;
    type: PartnerSupportType;
}

export class GetSimpleAgentListDto implements IGetSimpleAgentListDto {
    id: number;
    name: string | undefined;

    constructor(data?: IGetSimpleAgentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): GetSimpleAgentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSimpleAgentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): GetSimpleAgentListDto {
        const json = this.toJSON();
        let result = new GetSimpleAgentListDto();
        result.init(json);
        return result;
    }
}

export interface IGetSimpleAgentListDto {
    id: number;
    name: string | undefined;
}

export class GetUserListOutput implements IGetUserListOutput {
    id: number;
    name: string | undefined;
    surname: string | undefined;

    constructor(data?: IGetUserListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.surname = _data['surname'];
        }
    }

    static fromJS(data: any): GetUserListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['surname'] = this.surname;
        return data;
    }

    clone(): GetUserListOutput {
        const json = this.toJSON();
        let result = new GetUserListOutput();
        result.init(json);
        return result;
    }
}

export interface IGetUserListOutput {
    id: number;
    name: string | undefined;
    surname: string | undefined;
}

export class GetUsersFilteredByRoleOutput implements IGetUsersFilteredByRoleOutput {
    userList: UserListDto;
    isAssigned: boolean;

    constructor(data?: IGetUsersFilteredByRoleOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userList = new UserListDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userList = _data['userList'] ? UserListDto.fromJS(_data['userList']) : new UserListDto();
            this.isAssigned = _data['isAssigned'];
        }
    }

    static fromJS(data: any): GetUsersFilteredByRoleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersFilteredByRoleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userList'] = this.userList ? this.userList.toJSON() : <any>undefined;
        data['isAssigned'] = this.isAssigned;
        return data;
    }

    clone(): GetUsersFilteredByRoleOutput {
        const json = this.toJSON();
        let result = new GetUsersFilteredByRoleOutput();
        result.init(json);
        return result;
    }
}

export interface IGetUsersFilteredByRoleOutput {
    userList: UserListDto;
    isAssigned: boolean;
}

export class GetUsersFilteredByRoleOutputPagedResultDto implements IGetUsersFilteredByRoleOutputPagedResultDto {
    totalCount: number;
    items: GetUsersFilteredByRoleOutput[] | undefined;

    constructor(data?: IGetUsersFilteredByRoleOutputPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(GetUsersFilteredByRoleOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUsersFilteredByRoleOutputPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersFilteredByRoleOutputPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetUsersFilteredByRoleOutputPagedResultDto {
        const json = this.toJSON();
        let result = new GetUsersFilteredByRoleOutputPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGetUsersFilteredByRoleOutputPagedResultDto {
    totalCount: number;
    items: GetUsersFilteredByRoleOutput[] | undefined;
}

export class MarketingPartnerList implements IMarketingPartnerList {
    partner: string | undefined;
    partnerStatus: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    userStatus: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    partnerPrincipal: string | undefined;
    salesAgent: string | undefined;
    partnerCommissions: string | undefined;
    partnerAdmin: string | undefined;
    spm: string | undefined;

    constructor(data?: IMarketingPartnerList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data['partner'];
            this.partnerStatus = _data['partnerStatus'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            this.userStatus = _data['userStatus'];
            this.email = _data['email'];
            this.phone = _data['phone'];
            this.state = _data['state'];
            this.zip = _data['zip'];
            this.partnerPrincipal = _data['partnerPrincipal'];
            this.salesAgent = _data['salesAgent'];
            this.partnerCommissions = _data['partnerCommissions'];
            this.partnerAdmin = _data['partnerAdmin'];
            this.spm = _data['spm'];
        }
    }

    static fromJS(data: any): MarketingPartnerList {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingPartnerList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partner'] = this.partner;
        data['partnerStatus'] = this.partnerStatus;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['userStatus'] = this.userStatus;
        data['email'] = this.email;
        data['phone'] = this.phone;
        data['state'] = this.state;
        data['zip'] = this.zip;
        data['partnerPrincipal'] = this.partnerPrincipal;
        data['salesAgent'] = this.salesAgent;
        data['partnerCommissions'] = this.partnerCommissions;
        data['partnerAdmin'] = this.partnerAdmin;
        data['spm'] = this.spm;
        return data;
    }

    clone(): MarketingPartnerList {
        const json = this.toJSON();
        let result = new MarketingPartnerList();
        result.init(json);
        return result;
    }
}

export interface IMarketingPartnerList {
    partner: string | undefined;
    partnerStatus: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    userStatus: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    partnerPrincipal: string | undefined;
    salesAgent: string | undefined;
    partnerCommissions: string | undefined;
    partnerAdmin: string | undefined;
    spm: string | undefined;
}

export class MasterAgencyInputDto implements IMasterAgencyInputDto {
    id: number;
    name: string | undefined;
    isMCRevenue: boolean;

    constructor(data?: IMasterAgencyInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.isMCRevenue = _data['isMCRevenue'];
        }
    }

    static fromJS(data: any): MasterAgencyInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterAgencyInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['isMCRevenue'] = this.isMCRevenue;
        return data;
    }

    clone(): MasterAgencyInputDto {
        const json = this.toJSON();
        let result = new MasterAgencyInputDto();
        result.init(json);
        return result;
    }
}

export interface IMasterAgencyInputDto {
    id: number;
    name: string | undefined;
    isMCRevenue: boolean;
}

export class PartnerAcquisitionDto implements IPartnerAcquisitionDto {
    readonly name: string | undefined;
    isMatrixEnabled: boolean;
    isDefault: boolean;
    id: number;

    constructor(data?: IPartnerAcquisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data['name'];
            this.isMatrixEnabled = _data['isMatrixEnabled'];
            this.isDefault = _data['isDefault'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerAcquisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerAcquisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['isMatrixEnabled'] = this.isMatrixEnabled;
        data['isDefault'] = this.isDefault;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerAcquisitionDto {
        const json = this.toJSON();
        let result = new PartnerAcquisitionDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerAcquisitionDto {
    name: string | undefined;
    isMatrixEnabled: boolean;
    isDefault: boolean;
    id: number;
}

export class PartnerAcquisitionEditDto implements IPartnerAcquisitionEditDto {
    name: string | undefined;
    isMatrixEnabled: boolean;
    isDefault: boolean;
    id: number | undefined;

    constructor(data?: IPartnerAcquisitionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.isMatrixEnabled = _data['isMatrixEnabled'];
            this.isDefault = _data['isDefault'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerAcquisitionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerAcquisitionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['isMatrixEnabled'] = this.isMatrixEnabled;
        data['isDefault'] = this.isDefault;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerAcquisitionEditDto {
        const json = this.toJSON();
        let result = new PartnerAcquisitionEditDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerAcquisitionEditDto {
    name: string | undefined;
    isMatrixEnabled: boolean;
    isDefault: boolean;
    id: number | undefined;
}

export class PartnerAddressListDto implements IPartnerAddressListDto {
    address: string;

    constructor(data?: IPartnerAddressListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data['address'];
        }
    }

    static fromJS(data: any): PartnerAddressListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerAddressListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['address'] = this.address;
        return data;
    }

    clone(): PartnerAddressListDto {
        const json = this.toJSON();
        let result = new PartnerAddressListDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerAddressListDto {
    address: string;
}

export enum PartnerContactTermStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class PartnerContractTermDto implements IPartnerContractTermDto {
    partnerId: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    commissionTrackingTypeId: number | undefined;
    commissionTrackingType: CommissionTrackingTypeDto;
    rate: number;
    providerId: number;
    provider: ProviderEditDto;
    customerId: number;
    customer: CustomerDto;
    notes: string | undefined;
    parentOwnerId: number;
    parentOwner: PartnerAcquisitionDto;
    splits: PartnerContractTermSplitDto[] | undefined;
    salesCampaignId: number | undefined;
    salesCampaignName: string | undefined;
    id: number;

    constructor(data?: IPartnerContractTermDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.commissionTrackingTypeId = _data['commissionTrackingTypeId'];
            this.commissionTrackingType = _data['commissionTrackingType']
                ? CommissionTrackingTypeDto.fromJS(_data['commissionTrackingType'])
                : <any>undefined;
            this.rate = _data['rate'];
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? ProviderEditDto.fromJS(_data['provider']) : <any>undefined;
            this.customerId = _data['customerId'];
            this.customer = _data['customer'] ? CustomerDto.fromJS(_data['customer']) : <any>undefined;
            this.notes = _data['notes'];
            this.parentOwnerId = _data['parentOwnerId'];
            this.parentOwner = _data['parentOwner'] ? PartnerAcquisitionDto.fromJS(_data['parentOwner']) : <any>undefined;
            if (Array.isArray(_data['splits'])) {
                this.splits = [] as any;
                for (let item of _data['splits']) this.splits.push(PartnerContractTermSplitDto.fromJS(item));
            }
            this.salesCampaignId = _data['salesCampaignId'];
            this.salesCampaignName = _data['salesCampaignName'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerContractTermDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerContractTermDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['commissionTrackingTypeId'] = this.commissionTrackingTypeId;
        data['commissionTrackingType'] = this.commissionTrackingType ? this.commissionTrackingType.toJSON() : <any>undefined;
        data['rate'] = this.rate;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['customerId'] = this.customerId;
        data['customer'] = this.customer ? this.customer.toJSON() : <any>undefined;
        data['notes'] = this.notes;
        data['parentOwnerId'] = this.parentOwnerId;
        data['parentOwner'] = this.parentOwner ? this.parentOwner.toJSON() : <any>undefined;
        if (Array.isArray(this.splits)) {
            data['splits'] = [];
            for (let item of this.splits) data['splits'].push(item.toJSON());
        }
        data['salesCampaignId'] = this.salesCampaignId;
        data['salesCampaignName'] = this.salesCampaignName;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerContractTermDto {
        const json = this.toJSON();
        let result = new PartnerContractTermDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerContractTermDto {
    partnerId: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    commissionTrackingTypeId: number | undefined;
    commissionTrackingType: CommissionTrackingTypeDto;
    rate: number;
    providerId: number;
    provider: ProviderEditDto;
    customerId: number;
    customer: CustomerDto;
    notes: string | undefined;
    parentOwnerId: number;
    parentOwner: PartnerAcquisitionDto;
    splits: PartnerContractTermSplitDto[] | undefined;
    salesCampaignId: number | undefined;
    salesCampaignName: string | undefined;
    id: number;
}

export class PartnerContractTermDtoPagedResultDto implements IPartnerContractTermDtoPagedResultDto {
    totalCount: number;
    items: PartnerContractTermDto[] | undefined;

    constructor(data?: IPartnerContractTermDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(PartnerContractTermDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartnerContractTermDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerContractTermDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): PartnerContractTermDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PartnerContractTermDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerContractTermDtoPagedResultDto {
    totalCount: number;
    items: PartnerContractTermDto[] | undefined;
}

export class PartnerContractTermSplitDto implements IPartnerContractTermSplitDto {
    id: number;
    type: SplitType;
    advisorId: number | undefined;
    salesRepresentativeId: number;
    rate: number;

    constructor(data?: IPartnerContractTermSplitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.type = _data['type'];
            this.advisorId = _data['advisorId'];
            this.salesRepresentativeId = _data['salesRepresentativeId'];
            this.rate = _data['rate'];
        }
    }

    static fromJS(data: any): PartnerContractTermSplitDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerContractTermSplitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['type'] = this.type;
        data['advisorId'] = this.advisorId;
        data['salesRepresentativeId'] = this.salesRepresentativeId;
        data['rate'] = this.rate;
        return data;
    }

    clone(): PartnerContractTermSplitDto {
        const json = this.toJSON();
        let result = new PartnerContractTermSplitDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerContractTermSplitDto {
    id: number;
    type: SplitType;
    advisorId: number | undefined;
    salesRepresentativeId: number;
    rate: number;
}

export class PartnerContractTermsEditDto implements IPartnerContractTermsEditDto {
    partnerId: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    commissionTrackingTypeId: number;
    rate: number;
    providerId: number | undefined;
    customerId: number | undefined;
    notes: string | undefined;
    parentOwnerId: number;
    salesCampaignId: number | undefined;
    splits: PartnerContractTermSplitDto[] | undefined;
    id: number | undefined;

    constructor(data?: IPartnerContractTermsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.commissionTrackingTypeId = _data['commissionTrackingTypeId'];
            this.rate = _data['rate'];
            this.providerId = _data['providerId'];
            this.customerId = _data['customerId'];
            this.notes = _data['notes'];
            this.parentOwnerId = _data['parentOwnerId'];
            this.salesCampaignId = _data['salesCampaignId'];
            if (Array.isArray(_data['splits'])) {
                this.splits = [] as any;
                for (let item of _data['splits']) this.splits.push(PartnerContractTermSplitDto.fromJS(item));
            }
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerContractTermsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerContractTermsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['commissionTrackingTypeId'] = this.commissionTrackingTypeId;
        data['rate'] = this.rate;
        data['providerId'] = this.providerId;
        data['customerId'] = this.customerId;
        data['notes'] = this.notes;
        data['parentOwnerId'] = this.parentOwnerId;
        data['salesCampaignId'] = this.salesCampaignId;
        if (Array.isArray(this.splits)) {
            data['splits'] = [];
            for (let item of this.splits) data['splits'].push(item.toJSON());
        }
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerContractTermsEditDto {
        const json = this.toJSON();
        let result = new PartnerContractTermsEditDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerContractTermsEditDto {
    partnerId: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    commissionTrackingTypeId: number;
    rate: number;
    providerId: number | undefined;
    customerId: number | undefined;
    notes: string | undefined;
    parentOwnerId: number;
    salesCampaignId: number | undefined;
    splits: PartnerContractTermSplitDto[] | undefined;
    id: number | undefined;
}

export class PartnerContractTypeListDto implements IPartnerContractTypeListDto {
    name: string | undefined;
    isEnabled: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPartnerContractTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.isEnabled = _data['isEnabled'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerContractTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerContractTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['isEnabled'] = this.isEnabled;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerContractTypeListDto {
        const json = this.toJSON();
        let result = new PartnerContractTypeListDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerContractTypeListDto {
    name: string | undefined;
    isEnabled: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PartnerCustomerLocListDto implements IPartnerCustomerLocListDto {
    id: number;
    name: string | undefined;

    constructor(data?: IPartnerCustomerLocListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): PartnerCustomerLocListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerCustomerLocListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): PartnerCustomerLocListDto {
        const json = this.toJSON();
        let result = new PartnerCustomerLocListDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerCustomerLocListDto {
    id: number;
    name: string | undefined;
}

export class PartnerDetailsForQuoteList implements IPartnerDetailsForQuoteList {
    name: string;
    id: number;

    constructor(data?: IPartnerDetailsForQuoteList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerDetailsForQuoteList {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerDetailsForQuoteList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerDetailsForQuoteList {
        const json = this.toJSON();
        let result = new PartnerDetailsForQuoteList();
        result.init(json);
        return result;
    }
}

export interface IPartnerDetailsForQuoteList {
    name: string;
    id: number;
}

export class PartnerDevelopmentEditDto implements IPartnerDevelopmentEditDto {
    partnerId: number;
    partnerUserId: number;
    providerId: number;
    providerUserId: number;
    status: PartnerDevelopmentStatus;
    note: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPartnerDevelopmentEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.partnerUserId = _data['partnerUserId'];
            this.providerId = _data['providerId'];
            this.providerUserId = _data['providerUserId'];
            this.status = _data['status'];
            this.note = _data['note'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerDevelopmentEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerDevelopmentEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['partnerUserId'] = this.partnerUserId;
        data['providerId'] = this.providerId;
        data['providerUserId'] = this.providerUserId;
        data['status'] = this.status;
        data['note'] = this.note;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerDevelopmentEditDto {
        const json = this.toJSON();
        let result = new PartnerDevelopmentEditDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerDevelopmentEditDto {
    partnerId: number;
    partnerUserId: number;
    providerId: number;
    providerUserId: number;
    status: PartnerDevelopmentStatus;
    note: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum PartnerDevelopmentStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class PartnerDocumentDto implements IPartnerDocumentDto {
    partnerId: number;
    name: string;
    documentId: string;
    createdBy: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPartnerDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.name = _data['name'];
            this.documentId = _data['documentId'];
            this.createdBy = _data['createdBy'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['name'] = this.name;
        data['documentId'] = this.documentId;
        data['createdBy'] = this.createdBy;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerDocumentDto {
        const json = this.toJSON();
        let result = new PartnerDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerDocumentDto {
    partnerId: number;
    name: string;
    documentId: string;
    createdBy: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PartnerDropdownDto implements IPartnerDropdownDto {
    id: number;
    name: string | undefined;
    principalName: string | undefined;

    constructor(data?: IPartnerDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.principalName = _data['principalName'];
        }
    }

    static fromJS(data: any): PartnerDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['principalName'] = this.principalName;
        return data;
    }

    clone(): PartnerDropdownDto {
        const json = this.toJSON();
        let result = new PartnerDropdownDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerDropdownDto {
    id: number;
    name: string | undefined;
    principalName: string | undefined;
}

export class PartnerListDto implements IPartnerListDto {
    name: string;
    website: string;
    address: string;
    address2: string;
    city: string;
    state: string;
    zipcode: string;
    taxId: string;
    isApproved: boolean;
    isDirectDeposit: boolean;
    approveTime: moment.Moment;
    contractTypeId: number;
    contractType: PartnerContractTypeListDto;
    partnerStatus: PartnerStatus;
    partnerSupports: PartnerSupportEditDto[] | undefined;
    partnerAcquisitionId: number;
    partnerAcquisition: PartnerAcquisitionListDto;
    id: number;

    constructor(data?: IPartnerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.website = _data['website'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.taxId = _data['taxId'];
            this.isApproved = _data['isApproved'];
            this.isDirectDeposit = _data['isDirectDeposit'];
            this.approveTime = _data['approveTime'] ? moment(_data['approveTime'].toString()) : <any>undefined;
            this.contractTypeId = _data['contractTypeId'];
            this.contractType = _data['contractType'] ? PartnerContractTypeListDto.fromJS(_data['contractType']) : <any>undefined;
            this.partnerStatus = _data['partnerStatus'];
            if (Array.isArray(_data['partnerSupports'])) {
                this.partnerSupports = [] as any;
                for (let item of _data['partnerSupports']) this.partnerSupports.push(PartnerSupportEditDto.fromJS(item));
            }
            this.partnerAcquisitionId = _data['partnerAcquisitionId'];
            this.partnerAcquisition = _data['partnerAcquisition']
                ? PartnerAcquisitionListDto.fromJS(_data['partnerAcquisition'])
                : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['website'] = this.website;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['taxId'] = this.taxId;
        data['isApproved'] = this.isApproved;
        data['isDirectDeposit'] = this.isDirectDeposit;
        data['approveTime'] = this.approveTime ? this.approveTime.toISOString() : <any>undefined;
        data['contractTypeId'] = this.contractTypeId;
        data['contractType'] = this.contractType ? this.contractType.toJSON() : <any>undefined;
        data['partnerStatus'] = this.partnerStatus;
        if (Array.isArray(this.partnerSupports)) {
            data['partnerSupports'] = [];
            for (let item of this.partnerSupports) data['partnerSupports'].push(item.toJSON());
        }
        data['partnerAcquisitionId'] = this.partnerAcquisitionId;
        data['partnerAcquisition'] = this.partnerAcquisition ? this.partnerAcquisition.toJSON() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerListDto {
        const json = this.toJSON();
        let result = new PartnerListDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerListDto {
    name: string;
    website: string;
    address: string;
    address2: string;
    city: string;
    state: string;
    zipcode: string;
    taxId: string;
    isApproved: boolean;
    isDirectDeposit: boolean;
    approveTime: moment.Moment;
    contractTypeId: number;
    contractType: PartnerContractTypeListDto;
    partnerStatus: PartnerStatus;
    partnerSupports: PartnerSupportEditDto[] | undefined;
    partnerAcquisitionId: number;
    partnerAcquisition: PartnerAcquisitionListDto;
    id: number;
}

export class PartnerListDtoPagedResultDto implements IPartnerListDtoPagedResultDto {
    totalCount: number;
    items: PartnerListDto[] | undefined;

    constructor(data?: IPartnerListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(PartnerListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartnerListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): PartnerListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PartnerListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerListDtoPagedResultDto {
    totalCount: number;
    items: PartnerListDto[] | undefined;
}

export class PartnerPrincipleInformationDto implements IPartnerPrincipleInformationDto {
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;

    constructor(data?: IPartnerPrincipleInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.email = _data['email'];
            this.phone = _data['phone'];
        }
    }

    static fromJS(data: any): PartnerPrincipleInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerPrincipleInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['email'] = this.email;
        data['phone'] = this.phone;
        return data;
    }

    clone(): PartnerPrincipleInformationDto {
        const json = this.toJSON();
        let result = new PartnerPrincipleInformationDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerPrincipleInformationDto {
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
}

export class PartnerSalesSupportEditDto implements IPartnerSalesSupportEditDto {
    tenantId: number | undefined;
    partnerId: number;
    partner: PartnersDto;
    name: string | undefined;
    id: number;

    constructor(data?: IPartnerSalesSupportEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? PartnersDto.fromJS(_data['partner']) : <any>undefined;
            this.name = _data['name'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerSalesSupportEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSalesSupportEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerSalesSupportEditDto {
        const json = this.toJSON();
        let result = new PartnerSalesSupportEditDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerSalesSupportEditDto {
    tenantId: number | undefined;
    partnerId: number;
    partner: PartnersDto;
    name: string | undefined;
    id: number;
}

export class PartnerSalesSupportListDto implements IPartnerSalesSupportListDto {
    name: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPartnerSalesSupportListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerSalesSupportListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSalesSupportListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerSalesSupportListDto {
        const json = this.toJSON();
        let result = new PartnerSalesSupportListDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerSalesSupportListDto {
    name: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PartnerSourceEditDto implements IPartnerSourceEditDto {
    id: number | undefined;
    partnerId: number;
    type: PartnerSourceType;
    name: string;

    constructor(data?: IPartnerSourceEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.partnerId = _data['partnerId'];
            this.type = _data['type'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): PartnerSourceEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSourceEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['partnerId'] = this.partnerId;
        data['type'] = this.type;
        data['name'] = this.name;
        return data;
    }

    clone(): PartnerSourceEditDto {
        const json = this.toJSON();
        let result = new PartnerSourceEditDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerSourceEditDto {
    id: number | undefined;
    partnerId: number;
    type: PartnerSourceType;
    name: string;
}

export class PartnerSubAgencyEditDto implements IPartnerSubAgencyEditDto {
    tenantId: number | undefined;
    partnerId: number;
    partner: Partner;
    name: string | undefined;
    subAgencyPercent: number | undefined;
    id: number;

    constructor(data?: IPartnerSubAgencyEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? Partner.fromJS(_data['partner']) : <any>undefined;
            this.name = _data['name'];
            this.subAgencyPercent = _data['subAgencyPercent'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerSubAgencyEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSubAgencyEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['subAgencyPercent'] = this.subAgencyPercent;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerSubAgencyEditDto {
        const json = this.toJSON();
        let result = new PartnerSubAgencyEditDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerSubAgencyEditDto {
    tenantId: number | undefined;
    partnerId: number;
    partner: Partner;
    name: string | undefined;
    subAgencyPercent: number | undefined;
    id: number;
}

export class PartnerSubAgencyListDto implements IPartnerSubAgencyListDto {
    partnerId: number;
    partner: PartnersDto;
    name: string | undefined;
    subAgencyPercent: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPartnerSubAgencyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? PartnersDto.fromJS(_data['partner']) : <any>undefined;
            this.name = _data['name'];
            this.subAgencyPercent = _data['subAgencyPercent'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerSubAgencyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSubAgencyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['subAgencyPercent'] = this.subAgencyPercent;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerSubAgencyListDto {
        const json = this.toJSON();
        let result = new PartnerSubAgencyListDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerSubAgencyListDto {
    partnerId: number;
    partner: PartnersDto;
    name: string | undefined;
    subAgencyPercent: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PartnerUserReport implements IPartnerUserReport {
    spm: string | undefined;
    partnerName: string | undefined;
    partnerSince: moment.Moment | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    approvedDate: moment.Moment | undefined;

    constructor(data?: IPartnerUserReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spm = _data['spm'];
            this.partnerName = _data['partnerName'];
            this.partnerSince = _data['partnerSince'] ? moment(_data['partnerSince'].toString()) : <any>undefined;
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
            this.phoneNumber = _data['phoneNumber'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zip = _data['zip'];
            this.lastLoginTime = _data['lastLoginTime'] ? moment(_data['lastLoginTime'].toString()) : <any>undefined;
            this.approvedDate = _data['approvedDate'] ? moment(_data['approvedDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PartnerUserReport {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerUserReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['spm'] = this.spm;
        data['partnerName'] = this.partnerName;
        data['partnerSince'] = this.partnerSince ? this.partnerSince.toISOString() : <any>undefined;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        data['phoneNumber'] = this.phoneNumber;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zip'] = this.zip;
        data['lastLoginTime'] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data['approvedDate'] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): PartnerUserReport {
        const json = this.toJSON();
        let result = new PartnerUserReport();
        result.init(json);
        return result;
    }
}

export interface IPartnerUserReport {
    spm: string | undefined;
    partnerName: string | undefined;
    partnerSince: moment.Moment | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    approvedDate: moment.Moment | undefined;
}

export class PartnersAndUsersListDto implements IPartnersAndUsersListDto {
    id: number;
    name: string | undefined;
    partner: string | undefined;
    partnerApid: number | undefined;
    principal: string | undefined;
    principalEmail: string | undefined;
    spmName: string | undefined;
    spmEmail: string | undefined;
    pmName: string | undefined;
    pmEmail: string | undefined;
    ioName: string | undefined;
    ioEmail: string | undefined;
    isApproved: boolean;
    status: string | undefined;

    constructor(data?: IPartnersAndUsersListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.partner = _data['partner'];
            this.partnerApid = _data['partnerApid'];
            this.principal = _data['principal'];
            this.principalEmail = _data['principalEmail'];
            this.spmName = _data['spmName'];
            this.spmEmail = _data['spmEmail'];
            this.pmName = _data['pmName'];
            this.pmEmail = _data['pmEmail'];
            this.ioName = _data['ioName'];
            this.ioEmail = _data['ioEmail'];
            this.isApproved = _data['isApproved'];
            this.status = _data['status'];
        }
    }

    static fromJS(data: any): PartnersAndUsersListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnersAndUsersListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['partner'] = this.partner;
        data['partnerApid'] = this.partnerApid;
        data['principal'] = this.principal;
        data['principalEmail'] = this.principalEmail;
        data['spmName'] = this.spmName;
        data['spmEmail'] = this.spmEmail;
        data['pmName'] = this.pmName;
        data['pmEmail'] = this.pmEmail;
        data['ioName'] = this.ioName;
        data['ioEmail'] = this.ioEmail;
        data['isApproved'] = this.isApproved;
        data['status'] = this.status;
        return data;
    }

    clone(): PartnersAndUsersListDto {
        const json = this.toJSON();
        let result = new PartnersAndUsersListDto();
        result.init(json);
        return result;
    }
}

export interface IPartnersAndUsersListDto {
    id: number;
    name: string | undefined;
    partner: string | undefined;
    partnerApid: number | undefined;
    principal: string | undefined;
    principalEmail: string | undefined;
    spmName: string | undefined;
    spmEmail: string | undefined;
    pmName: string | undefined;
    pmEmail: string | undefined;
    ioName: string | undefined;
    ioEmail: string | undefined;
    isApproved: boolean;
    status: string | undefined;
}

export class SalesAgentPartnerListForQuote implements ISalesAgentPartnerListForQuote {
    salesAgentNames: UserListDto[] | undefined;
    partnerNames: PartnerDetailsForQuoteList;

    constructor(data?: ISalesAgentPartnerListForQuote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['salesAgentNames'])) {
                this.salesAgentNames = [] as any;
                for (let item of _data['salesAgentNames']) this.salesAgentNames.push(UserListDto.fromJS(item));
            }
            this.partnerNames = _data['partnerNames'] ? PartnerDetailsForQuoteList.fromJS(_data['partnerNames']) : <any>undefined;
        }
    }

    static fromJS(data: any): SalesAgentPartnerListForQuote {
        data = typeof data === 'object' ? data : {};
        let result = new SalesAgentPartnerListForQuote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.salesAgentNames)) {
            data['salesAgentNames'] = [];
            for (let item of this.salesAgentNames) data['salesAgentNames'].push(item.toJSON());
        }
        data['partnerNames'] = this.partnerNames ? this.partnerNames.toJSON() : <any>undefined;
        return data;
    }

    clone(): SalesAgentPartnerListForQuote {
        const json = this.toJSON();
        let result = new SalesAgentPartnerListForQuote();
        result.init(json);
        return result;
    }
}

export interface ISalesAgentPartnerListForQuote {
    salesAgentNames: UserListDto[] | undefined;
    partnerNames: PartnerDetailsForQuoteList;
}

export class SupportContactDto implements ISupportContactDto {
    firstName: string | undefined;
    surname: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    uuid: string | undefined;
    profilePictureURL: string | undefined;

    constructor(data?: ISupportContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data['firstName'];
            this.surname = _data['surname'];
            this.email = _data['email'];
            this.phone = _data['phone'];
            this.uuid = _data['uuid'];
            this.profilePictureURL = _data['profilePictureURL'];
        }
    }

    static fromJS(data: any): SupportContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['firstName'] = this.firstName;
        data['surname'] = this.surname;
        data['email'] = this.email;
        data['phone'] = this.phone;
        data['uuid'] = this.uuid;
        data['profilePictureURL'] = this.profilePictureURL;
        return data;
    }

    clone(): SupportContactDto {
        const json = this.toJSON();
        let result = new SupportContactDto();
        result.init(json);
        return result;
    }
}

export interface ISupportContactDto {
    firstName: string | undefined;
    surname: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    uuid: string | undefined;
    profilePictureURL: string | undefined;
}

export class UpdatePartnerDevelopmentStatusInput implements IUpdatePartnerDevelopmentStatusInput {
    partnerDevelopmentId: number;
    partnerDevelopmentStatus: string | undefined;

    constructor(data?: IUpdatePartnerDevelopmentStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerDevelopmentId = _data['partnerDevelopmentId'];
            this.partnerDevelopmentStatus = _data['partnerDevelopmentStatus'];
        }
    }

    static fromJS(data: any): UpdatePartnerDevelopmentStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerDevelopmentStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerDevelopmentId'] = this.partnerDevelopmentId;
        data['partnerDevelopmentStatus'] = this.partnerDevelopmentStatus;
        return data;
    }

    clone(): UpdatePartnerDevelopmentStatusInput {
        const json = this.toJSON();
        let result = new UpdatePartnerDevelopmentStatusInput();
        result.init(json);
        return result;
    }
}

export interface IUpdatePartnerDevelopmentStatusInput {
    partnerDevelopmentId: number;
    partnerDevelopmentStatus: string | undefined;
}

export class UserPartnerSupportInfoDto implements IUserPartnerSupportInfoDto {
    isAssigned: boolean;
    name: string;
    surname: string;
    id: number;

    constructor(data?: IUserPartnerSupportInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAssigned = _data['isAssigned'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): UserPartnerSupportInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPartnerSupportInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['isAssigned'] = this.isAssigned;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['id'] = this.id;
        return data;
    }

    clone(): UserPartnerSupportInfoDto {
        const json = this.toJSON();
        let result = new UserPartnerSupportInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserPartnerSupportInfoDto {
    isAssigned: boolean;
    name: string;
    surname: string;
    id: number;
}

export class ValidationResponse implements IValidationResponse {
    readonly hasError: boolean;
    readonly errorMessage: string | undefined;

    constructor(data?: IValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).hasError = _data['hasError'];
            (<any>this).errorMessage = _data['errorMessage'];
        }
    }

    static fromJS(data: any): ValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['hasError'] = this.hasError;
        data['errorMessage'] = this.errorMessage;
        return data;
    }

    clone(): ValidationResponse {
        const json = this.toJSON();
        let result = new ValidationResponse();
        result.init(json);
        return result;
    }
}

export interface IValidationResponse {
    hasError: boolean;
    errorMessage: string | undefined;
}
